import PSY_URI from '@/assets/Utils/api/url-const'
import { GET ,POST } from '@/assets/Utils/api/http';


/*
* 产品类别列表
* @param {}
* */

export const GetProductCategoryList =()=>{
  return GET(PSY_URI.PRODUCT_CATEGORY_LIST);
}


/*
*   官网产品动态列表
 * @param{
 *    page 当前页码
 *    limit 每页条数
 *    typeCode 产品类别编码
 * }
 * */
export  const  GetProductsDynamicList =(param)=>{

    return GET(PSY_URI.PRODUCTS_AND_SERVICES,{
      data:param
    });
  }